import * as s from "styles/ModalCommonStyled";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import BigButton from "components/atoms/buttons/BigButton";
import { Validate } from "api/interfaces/commonInterface.interface";
import { videoGuideOptions, type Option } from "utils/options";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import { ValidateWord } from "components/atoms/text/Text";
import SelectComponent from "components/atoms/select/SelectComponent";
import { VideoGuideGroupDto } from "api/interfaces/managerInterface.interface";
import DeleteConfirmModal from "components/templates/modal/small/confirm/delete";
import Spinner from "components/atoms/loader/Spinner";
import { UPDATE_TYPE } from "./AddGroupContainer";

interface Props {
  isEdit: boolean;
  isDeleteConfirm: boolean;
  setIsDeleteConfirm: (value: boolean) => void;
  onClickDelete: () => void;
  isInProcess: boolean;
  onModal: (type?: string) => void;
  groupInfo: VideoGuideGroupDto;
  onChangeGroupInfo: (type: UPDATE_TYPE, value: string) => void;
  validate: Validate;
  validateMsg: ValidateMsg;
  layoutOptions: Option[];
  maxPosition: number;
  onSaveBefore: () => void;
}

export default function AddGroupPresenter(props: Props) {
  return (
    <BigPopupTemplate
      title={props.isEdit ? "Edit Group" : "Add Group"}
      onModal={props.onModal}
    >
      <ModalInput label="Category" essential>
        <SelectComponent
          options={videoGuideOptions}
          value={videoGuideOptions[0]?.value}
          disabled={true}
        />
      </ModalInput>
      <s.Row>
        <ModalInput label="Group Name" essential>
          <Input
            placeholder="Enter group name."
            pattern="[A-Za-z]+"
            maxLength={50}
            value={props.groupInfo.name}
            onChange={(e) => {
              props.onChangeGroupInfo(UPDATE_TYPE.GROUP_NAME, e.target.value);
            }}
            isValidated={props.validate.name}
            disabled={props.isInProcess}
            data-testid="manager-video-manager-group-input-change-group-info"
          />

          <ValidateWord data-testid="manager-video-manager-group-validate-name">
            {props.validateMsg.name}
          </ValidateWord>
        </ModalInput>
      </s.Row>

      <ModalInput label="Upload Type" essential>
        <SelectComponent
          options={props.layoutOptions}
          value={props.groupInfo.layout}
          onChange={(value: string) => {
            props.onChangeGroupInfo(UPDATE_TYPE.LAYOUT, value);
          }}
          disabled={props.isInProcess || props.isEdit}
          data-testid="manager-video-manager-group-select-change-layout"
        />
      </ModalInput>
      <s.Row>
        <ModalInput label="Group Position" essential>
          <Input
            placeholder="Enter group position."
            type="number"
            value={props.groupInfo.position}
            onChange={(e) => {
              props.onChangeGroupInfo(UPDATE_TYPE.POSITION, e.target.value);
            }}
            isValidated={props.validate.position}
            disabled={props.isInProcess}
            min={1}
            max={props.maxPosition}
            data-testid="manager-video-manager-group-input-change-group-info-2"
          />

          <ValidateWord data-testid="manager-video-manager-group-validate-position">
            {props.validateMsg.position}
          </ValidateWord>
        </ModalInput>
      </s.Row>

      <ActionBtns
        isEdit={props.isEdit}
        setIsDeleteConfirm={props.setIsDeleteConfirm}
        isInProcess={props.isInProcess}
        onSaveBefore={props.onSaveBefore}
      />

      {props.isEdit && props.isDeleteConfirm && (
        <DeleteConfirmModal
          label="VideoGuide"
          onDelete={() => props.setIsDeleteConfirm(false)}
          onConfirmDelete={props.onClickDelete}
        />
      )}
    </BigPopupTemplate>
  );
}

type ActionBtnsType = {
  isEdit: boolean | undefined;
  setIsDeleteConfirm: (value: boolean) => void;
  isInProcess: boolean;
  onSaveBefore: () => void;
};

const ActionBtns = ({
  isEdit,
  setIsDeleteConfirm,
  isInProcess,
  onSaveBefore,
}: ActionBtnsType) => {
  if (isInProcess) {
    return (
      <s.ButtonWrapper>
        <Spinner size={8} inline={true} />
      </s.ButtonWrapper>
    );
  }
  return (
    <s.ButtonWrapper>
      {isEdit && (
        <BigButton
          buttonType="warning"
          label="Delete"
          onClickBtn={() => setIsDeleteConfirm(true)}
          disabled={isInProcess}
          data-testid="manager-video-manager-group-button-delete"
        />
      )}
      <BigButton
        label="Save"
        onClickBtn={onSaveBefore}
        disabled={isInProcess}
        data-testid="manager-video-manager-group-button-save"
      />
    </s.ButtonWrapper>
  );
};
